import axios from 'axios';
import { aicaBaseUrl, GET } from '../../../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../../../utils/dateUtils';

interface GetFinancialsIngestionStatusParams {
    orgId: string;
    fileType: string;
}

/** Pattern: getMcaDocApiData (src/store/investor/service.ts:904-914) — params + timestamp shape. */
export function getFinancialsIngestionStatus({ orgId, fileType }: GetFinancialsIngestionStatusParams) {
    return axios({
        baseURL: aicaBaseUrl,
        url: '/data/org/financials/ingestionStatus',
        method: GET,
        params: {
            assesseeOrgId: orgId,
            fileType,
            requestId: getTimeStamp(),
        },
    });
}
